import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import PatientHome from './pages/PatientHome';
import ProviderHome from './pages/ProviderHome';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ShareView from './pages/ShareView';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/patient" element={<PatientHome />} />
        <Route path="/provider" element={<ProviderHome />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/share/:token" element={<ShareView />} />
      </Routes>
    </Router>
  );
}

export default App;
